import React, { useEffect, useState, Fragment } from 'react';
import axios from 'axios';
import Header from './Header';
import DefaultSidebar from './Sidebar'
import { Card, Typography } from "@material-tailwind/react";
import ModalCreateServeur from './ModalCreateServeur';
import ModalModifyServeur from './ModalModifyServeur';
import { toast, ToastContainer } from 'react-toastify'; // Import pour les notifications
import 'react-toastify/dist/ReactToastify.css';

function AnnuaireServer() {
    // const [datas, setDate] = useState([])
    const [listServer, setListServer] = useState([])
    const [sortedBy, setSortedBy] = useState()
    const [counter, setCounter] = useState(0)
    const [search, setSearch] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showModalModify, setShowModalModify] = useState(false);
    const [choosenClient, setChoosenClient] = useState({
        id: '',
        nom_serveur: '',
        url_serveur: '',
        version_serveur: '',
        nb_ecrans: '',
    });
    // const [open, setOpen] = useState('block')

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };


    useEffect(() => {
        // axios.get(`${process.env.REACT_APP_IP3}:${process.env.REACT_APP_PORT4}/get_serveur`)
        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/get_serveur`)
            .then(res => {
                // console.log(res);
                setListServer(res.data)
            })
            .catch(err => console.log(err))


    }, [])

    const TABLE_HEAD = [
        { key: "nom_serveur", text: "Nom Serveur" },
        { key: "url_serveur", text: "URL du serveur" },
        { key: "version_serveur", text: "Version" },
        { key: "nb_ecrans", text: "Nombre d'écrans" }
    ];


    const sorted = listServer.sort((a, b) => {

        const aVal = a[sortedBy];
        const bVal = b[sortedBy];
        if (typeof aVal === "number" && typeof bVal === "number") {
            if (counter % 2 === 0) return aVal - bVal;
            else return bVal - aVal;
        }
        else if (typeof aVal === "string" && typeof bVal === "string") {
            if (counter % 2 === 0) return aVal.localeCompare(bVal);
            else return bVal.localeCompare(aVal);
        }
        return 1;
    });


    const ListServer = (() => {
        return (
            <Card className="w-full overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
                <div className="overflow-x-auto">
                <table className="w-full min-w-max table-auto text-left">
                    <thead>
                        <tr className='sticky top-0 border-b border-slate-200 bg-slate-50'>
                            {TABLE_HEAD.map((head) => (
                                <th
                                    key={head.key}
                                    className="cursor-pointer whitespace-nowrap px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500 hover:text-slate-700"
                                    onClick={() => { setSortedBy(head.key); setCounter(counter + 1) }}
                                >
                                    <Typography
                                        variant="small"
                                        className="font-semibold leading-none uppercase tracking-wide"
                                    >
                                        {head.text}
                                    </Typography>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {sorted.filter((item) => {
                            return search.toLowerCase() === ''
                                ? item
                                : item.nom_serveur.toLowerCase().includes(search.toLowerCase()) || item.url_serveur.toLowerCase().includes(search.toLowerCase()) || item.version_serveur.toLowerCase().includes(search.toLowerCase())
                        }).map((data, index) => {
                            const isLast = index === data.length - 1;
                            const classes = isLast ? "whitespace-nowrap px-4 py-3 text-sm text-slate-700" : "whitespace-nowrap px-4 py-3 text-sm text-slate-700 border-b border-slate-100 cursor-pointer";

                            return (
                                <tr key={data.id} className="cursor-pointer border-b border-slate-100 transition-colors hover:bg-indigo-50/40" onClick={() => { setShowModalModify(true); setChoosenClient({ ...choosenClient, id: data.id, nom_serveur: data.nom_serveur, url_serveur: data.url_serveur, version_serveur: data.version_serveur }) }}>
                                    {/* <tr key={data.id} > */}
                                    <td className={classes}>
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {data.nom_serveur}
                                        </Typography>
                                    </td>
                                    <td className={classes} title="Cliquez pour copier l'adresse Server" onClick={(e) => {
                                        e.stopPropagation();
                                        navigator.clipboard.writeText(data.url_serveur).then(() => {
                                            toast.success("Lien server copié dans le presse-papier !", {
                                                position: "bottom-right",
                                                autoClose: 2000,
                                            });
                                        })
                                    }}>
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {data.url_serveur}
                                        </Typography>
                                    </td>
                                    <td className={classes}>
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {data.version_serveur}
                                        </Typography>
                                    </td>
                                    <td className={classes}>
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {data.nb_ecrans}
                                        </Typography>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                </div>
            </Card>
        );
    })

    return (
        <Fragment>
            <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6">
                {/* <Header /> */}
                <div className="mb-4">
                    <h1 className="text-xl font-semibold text-slate-800">Serveurs</h1>
                    <p className="text-sm text-slate-500">Annuaire des serveurs.</p>
                </div>
                <div className='max-w-md my-2'>
                    {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 absolute left-1 cursor-pointer" onClick={() => setOpen(open === `hidden`  ? 'block' : 'hidden')} >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                    </svg> */}
                    <div className="relative flex h-10 items-center rounded-xl border border-slate-200 bg-white shadow-sm focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-500/20">
                        <svg xmlns="http://www.w3.org/2000/svg" className="ml-3 h-5 w-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>

                        <input
                            className="h-full w-full rounded-xl bg-transparent px-3 text-sm text-slate-800 placeholder-slate-400 outline-none"
                            type="text"
                            id="search"
                            placeholder="Rechercher un serveur..."
                            onChange={(e) => setSearch(e.target.value)} />
                    </div>
                </div>
                <main className="flex flex-row justify-between mt-4">
                    {/* <DefaultSidebar  isOpen={open} /> */}
                    {ListServer()}
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 fixed bottom-16 right-6 cursor-pointer" onClick={() => scrollToTop()}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 fixed bottom-6 right-6 cursor-pointer" onClick={() => setShowModal(true)} >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </main>
            </div>
            <ModalCreateServeur isVisible={showModal} onClose={() => setShowModal(false)} />
            <ModalModifyServeur isVisible={showModalModify} onClose={() => setShowModalModify(false)} choosenClient={choosenClient} />
            <ToastContainer /> 

        </Fragment>
    )
}
export default AnnuaireServer;